import React from "react";

const TotalTable = ({totalItems}) => {
  return (
    <div className="tableQuote__total">
      Se encontraron <span>{totalItems}</span> resultados
    </div>
  )
};

export default TotalTable;